import { useQuery } from "@tanstack/react-query";
import { agentConversationsApi } from "@/api/agent-conversations";
import { queryKeys } from "@/lib/query-keys";

/**
 * Agent-to-agent conversations for a company. Polls on an interval so the
 * org chart's "live conversation" links stay current without a manual refresh.
 */
export function useAgentConversations(
  companyId: string,
  options?: { refetchInterval?: number },
) {
  return useQuery({
    queryKey: queryKeys.agentConversations.byCompany(companyId),
    queryFn: () => agentConversationsApi.listByCompany(companyId),
    enabled: !!companyId,
    refetchInterval: options?.refetchInterval ?? 30_000,
  });
}
